import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ICreateReportData } from "../interfaces/report";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root"
})
export class ReportService {
    constructor(private http: HttpClient) { }

    public CreateCirculationReport(data: ICreateReportData): Observable<void> {
        const url = `/api/Report/Create`;
        return this.http
        .post<void>(url, data, {
            responseType: "json"
        });
    }
}